import React, { Component, Dispatch } from 'react';
import { Log } from 'ng2-logger';
import Translator from '../../../core/i18n';
import { Common } from '../../../core/common';
import { IBaseFieldsProps, IOpenEndedStata } from '../../../models/components/add-question';
import Quil from '../../../components/input/quil/main';
import FileUpload from '../../../components/file-upload/main';
import BaseModalStatic from '../../../modal/base-modal/main-static';
import { FileService } from '../../../api/file-service';
import { Confirm, Notification } from '../../../components/notification/main';
import { FormikProps } from 'formik';
import { IQuestionData } from '../../../models/components/questions';
import { ActivityTypeEnums } from '../../../models/enums/ActivityType';

const T = Translator.create();
const _logger = Log.create('Open Ended');
let _common: Common;
const _fileService = new FileService();
const RegExpHtmlTags = /(<([^>]+)>)/gi;
const RegExpBase64 = /<img([^>]+)src="(data:image\/[^;]+;base64[^"]+)"/i;
export class BaseFields extends Component<IBaseFieldsProps, IOpenEndedStata> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            comment: '',
            hasComment:
                this.props.formik.values.questionComment &&
                    this.props.formik.values.questionComment.replace(RegExpBase64, 'image').replace(RegExpHtmlTags, '')
                    ? true
                    : false,
            isModalOpen: false,
            isPreviewFile: false,
            file: '',
            willDeleteFile: undefined,
            _file: undefined,
            onClickCommentEditor: false,
            onClickQuestionTextEditor: false
        };
    }

    componentDidMount() {
        if (this.props.formik.values.questionFileId) {
            void _common.GetImageUrl(this.props.formik.values.questionFile).then((url: any) => {
                this.setState({ isPreviewFile: true, file: url });
            });
        }
    }

    triggerModal = () => {
        if (this.props.formik.values.isExamQuestion) {
            return;
        }
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    getFileAsync = async (fileName: string) => {
        const params = { fileUploadId: this.props.fileInputKey, fileName };
        await _fileService
            .RequestGetFileAsync({ ...params })
            .then((response: Response) => {
                if (response.status !== 200) {
                    this.setState({ isPreviewFile: false, file: '' });
                }
                return response.json();
            })
            .then((responseData: any) => {
                this.setState({ isPreviewFile: true, file: responseData });
                this.triggerModal();
            })
            .catch(() => {
                this.setState({ isPreviewFile: false, file: '' });
            });
    };

    afterFileUpload = async (file: any) => {
        if (file) {
            this.setState({ _file: file });
            await this.getFileAsync(file.name);
        }
    };

    afterFileDelete = async () => {
        this.setState({ isPreviewFile: false, file: '' });
    };

    public handleDeleteFileConfirm = () => {
        if (this.props.formik.values.isExamQuestion) {
            Notification.setNotification(
                'error',
                T.t('r_api_gen_question_error_not_editable_exam_question'),
                'topRight'
            );
            return;
        }
        Confirm.setConfirm('normal', () => this.handleDeleteFile(), T.t('r_confirm_delete_photo'), null, null, undefined, true);
    };

    handleDeleteFile = () => {
        if (this.state._file) {
            this.setState({ willDeleteFile: this.state._file });
        } else {
            this.setState({ isPreviewFile: false, file: '' });
            this.props.formik.setFieldValue('questionFileId', '');
        }
    };

    handleHasComment = (value: boolean, formik: FormikProps<IQuestionData>) => {
        if (formik.values.isExamQuestion) {
            return;
        }
        if (formik && formik.values) {
            if (!value) {
                this.setState({ hasComment: value, comment: formik.values.questionComment });
                this.props.formik.setFieldValue('questionComment', '');
            } else {
                this.setState({ hasComment: value, comment: '' });
                this.props.formik.setFieldValue('questionComment', this.state.comment);
            }
        }
    };

    public render() {
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-12">
                        <a
                            className="attachment-btn"
                            type="button"
                            aria-expanded="false"
                            style={{ textAlign: "start" }}
                            // tslint:disable-next-line: jsx-no-lambda
                            onClick={this.handleHasComment.bind(this, !this.state.hasComment, this.props.formik)}
                            onClickCapture={() => {
                                if (this.props.formik.values.isExamQuestion) {
                                    Notification.setNotification(
                                        'error',
                                        T.t('r_api_gen_question_error_not_editable_exam_question'),
                                        'topRight'
                                    );
                                }

                            }}
                        >
                            <i className="material-icons mr-2">{this.state.hasComment ? 'remove' : 'add'}</i>
                            {T.t('r_question_attachment_content')}
                        </a>
                    </div>
                </div>

                <div className="row comment-question-add" style={{ display: this.state.hasComment ? 'block' : 'none' }}>
                    <Quil
                        modules={'basic'}
                        placeholder={T.t('r_question_attachment_content')}
                        // tslint:disable-next-line: jsx-no-lambda
                        onChange={(e: any) => this.props.formik.setFieldValue('questionComment', e)}
                        value={this.props.formik.values.questionComment || ''}
                        readonly={this.props.formik.values.isExamQuestion}
                    />
                </div>

                {!this.props.isFromMadlen &&
                    <>
                        <div className="row mt-4 ">
                            <div className="col-12">
                                <a className="attachment-btn attachment-btn-custom" type="button" aria-expanded="false"
                                    style={{ textAlign: "start" }}
                                    onClickCapture={() => {
                                        if (this.props.formik.values.isExamQuestion) {
                                            Notification.setNotification(
                                                'error',
                                                T.t('r_api_gen_question_error_not_editable_exam_question'),
                                                'topRight'
                                            );
                                        }

                                    }}>
                                    <i className="material-icons mr-2">attach_file</i>
                                    {T.t('r_question_add_photo_before_text')}{' '}
                                    <span className="text-azure" onClick={this.triggerModal} style={{ cursor: 'pointer' }}>
                                        {' '}
                                        {T.t('r_question_add_photo_after_text')}
                                    </span>
                                </a>
                            </div>
                        </div>
                        {this.state.isPreviewFile ? (
                            <div className="col-12 uploaded_file_container mt-4" style={{ display: 'flex', height: 400, justifyContent: 'center' }}>
                                <div className="uploaded_file">
                                    <img src={this.state.file} style={{ width: '100%', height: '100%' }} />
                                    <a onClick={this.handleDeleteFileConfirm} className="file_delete_btn">
                                        <i className="material-icons">close</i>
                                    </a>
                                </div>
                            </div>
                        ) : (
                            ''
                        )}

                        <div className="row mt-4 comment-question-add d-block">
                            <Quil
                                modules={'basic'}
                                placeholder={T.t('r_gen_questionBank_questionText') + " *"}
                                // tslint:disable-next-line: jsx-no-lambda
                                onChange={(e: any) => this.props.formik.setFieldValue('questionText', e)}
                                value={this.props.formik.values.questionText}
                                readonly={this.props.formik.values.isExamQuestion}

                            />
                        </div>
                    </>

                }




                <BaseModalStatic
                    minWidth={650}
                    modalIsOpen={this.state.isModalOpen}
                    onClose={this.triggerModal}
                    headerState={T.t('r_report_template_modal_header')}
                    headerIcon={'clock'}
                    modalBodyClassName={'modal-body pt-2 file-upload-modal-body'}
                    modalHeaderClassName={'modal-header border-0 d-flex justify-content-between p-0 file-upload-modal-header'}
                    modalContentClassName={'modal-content file-upload-modal-content'}
                >
                    <FileUpload
                        key={this.props.fileInputKey}
                        fileInputKey={this.props.fileInputKey}
                        height={400}
                        maxFileSize={2000000000}
                        maxSelectedFileCount={1}
                        isCardImage={false}
                        formik={this.props.formik}
                        fileTypes={".png,.jpg,.jpeg"}
                        afterUploaded={this.afterFileUpload}
                        afterDeleted={this.afterFileDelete}
                        willDeleteFile={this.state.willDeleteFile}
                    />
                </BaseModalStatic>
            </React.Fragment>
        );
    }
}
